export default "__VITE_ASSET__DhZ8pfkw__"